export const getFileNameForElectronicSignature = (file) => {
  if (!Boolean(file)) {
    return;
  }
  const splittedFullFileName = file.name.split('.');
  const fileNameWithoutExtension = splittedFullFileName[0].trim();
  const fileExtension = splittedFullFileName[1];
  return `${fileNameWithoutExtension}_sign.${fileExtension}`;
};
